import React from 'react';
import {
    Page
    , Content
    , Nav
    , Icon
    , PopUp
} from '@beisen/chaos-ui';
import ItemCard from './ItemCard';
import ApprovalUnstart from './ApprovalUnstart';
import * as format from '../format';
import * as helper from '../../util/helper';
require('./ApprovalInfoPanel.scss');
/*
"id": "d4800d99-6f81-4f4b-9904-f48747d3a405",
            "name": "第一审批人",
            "x": 0.0,
            "y": 0.0,
            "assignes": [
                {
                    "id": 107460817,
                    "name": "anxuenan",
                    "headPortrait": "",
                    "color": "#f79c6f",
                    approvalState: 1
                    "taskCompleteTime": '43/343',
                    "actionName": '驳回到上一级',
                    "comment": 'dfsdfsdfsdfdsfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsfsdfsdfsdfsdfsdfsd'
                }
            ],
            "assignesNames": 'anxuenan,sss'
            "status": 2,
            "isStart": false,
            "isEnd": false,
            "url": null,
            "time": 324/3423
*/
class ApprovalInfoPanel extends React.Component {

    constructor(props) {
        super(props);
        this.handleBack = this.handleBack.bind(this);
        this.approvalEnd = [];
        this.approvalUnstart = [];
        this.unstartNum = 0;
        this.endNum = 0;
        this.initData();
    }

    initData() {
        const { assignes } = this.props.info;
        assignes.map((item, index) => {
            if (item.approvalState == 1) {
                this.approvalEnd.push(item);
            } else {
                this.approvalUnstart.push(item);
            }
        });
        this.endNum = this.approvalEnd.length;
        this.unstartNum = this.approvalUnstart.length;
    }

    formatCardData(assigneItem, index) {
        if (assigneItem) {
            const cardInfo = {
                'maiTitle': assigneItem.name
                , 'subTitle': format.formatTime(assigneItem.taskCompleteTime)
                , 'hasAvatar': true
                , 'avatar': assigneItem
                , 'rightTag': assigneItem.actionName
                , 'botContent': assigneItem.comment
                , 'assignesNum': 1
                , 'status': assigneItem.approvalState
                , 'isEnd': false
                , 'isStart': true
            };
            return cardInfo;
        }
        return null;
    }

    handleBack(e) {
        e && e.preventDefault && e.preventDefault();
        this.props.closeInfo && this.props.closeInfo();
    }

    renderTitle(type) {
        const { approved,unapproved } = this.props.translation;
        let text, num;
        switch (type) {
            case 'end':
                text = approved;
                num = this.endNum;
                break;
            case 'unstart':
                text = unapproved;
                num = this.unstartNum;
                break;
            default:
                text = '';
                num = 0;
        }
        return num == 0 ? null : <div className="title-container">{text}<span className="title-num">{num}</span></div>;
    }



    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['ApprovalInfoPanelHandleBack'] = this.handleBack.bind(this);
    }
    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['ApprovalInfoPanelHandleBack'];
    }
    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        helper.clearHeaderConfig();
    }
    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        let title = this.props.info.name;
        helper.generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'ApprovalInfoPanelHandleBack',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            config.titleItem = {
                text: title,
                icon: '',
                callback: '',
                control: false
            };
            return config;
        });
    }

    componentDidMount() {
        if (helper.ifHidePopupNav()) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if (helper.ifHidePopupNav()) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    render() {
        const { info,translation } = this.props;
        let header = (<Nav>
            <Icon role="left" icon='m-sys-backward' className="approvalInfo-back" onTouchTap={this.handleBack} style={{ color: '#6B7175', fontSize: '20px' }} />
            <div role="center" className="approvalInfo-title">
                {info.name}
            </div>
        </Nav>);
        if(helper.ifHidePopupNav()) {
            header = null;
        }
        return (
            <PopUp visible={true}
                animation="right-slide-fade"
                maskAnimation="fade"
                cls='approvalInfo-pop'
                wrapClassName="approvalInfo-wrap"
                maskStyle={{ 'background': 'rgba(0,0,0,0)' }}
            >
                <Page>
                    {header}
                    <Content style={{ 'background': '#f3f4f5', 'padding': '12px' }}>
                        {this.renderTitle('end')}
                        {this.approvalEnd.map((data, index) => {
                            return <ItemCard translation={translation} info={this.formatCardData(data, index)} key={index} style={{ 'marginBottom': '8px' }} />;
                        })}
                        {this.renderTitle('unstart')}
                        <ApprovalUnstart data={this.approvalUnstart} />
                    </Content>
                </Page>
            </PopUp>
        );
    }
}

export default ApprovalInfoPanel;


// WEBPACK FOOTER //
// ./src/components/Approval/new/ApprovalInfoPanel.js